import React from "react";
import withStyles from "components/common/wrappers/withStyles";

const Statements = ({ color = "white", svgClassname }) => {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={svgClassname}
    >
      <path
        d="M9.33332 1.51302V4.26671C9.33332 4.64008 9.33332 4.82677 9.40599 4.96937C9.46992 5.09481 9.57186 5.1968 9.69732 5.26072C9.83992 5.33338 10.0266 5.33338 10.4 5.33338H13.1537M9.33332 11.3333H5.33332M10.6667 8.66667H5.33332M13.3333 6.65881V11.4667C13.3333 12.5868 13.3333 13.1468 13.1153 13.5747C12.9236 13.951 12.6177 14.2569 12.2413 14.4487C11.8135 14.6667 11.2535 14.6667 10.1333 14.6667H5.86666C4.74655 14.6667 4.1865 14.6667 3.75868 14.4487C3.38235 14.2569 3.07639 13.951 2.88464 13.5747C2.66666 13.1468 2.66666 12.5868 2.66666 11.4667V4.53333C2.66666 3.41323 2.66666 2.85317 2.88464 2.42535C3.07639 2.04903 3.38235 1.74307 3.75868 1.55132C4.1865 1.33333 4.74655 1.33333 5.86666 1.33333H8.00786C8.49699 1.33333 8.74159 1.33333 8.97179 1.38859C9.17586 1.43759 9.37092 1.51839 9.54992 1.62805C9.75172 1.75173 9.92466 1.92469 10.2706 2.27059L12.3961 4.39607C12.742 4.74198 12.9149 4.91493 13.0386 5.11677C13.1483 5.29571 13.2291 5.4908 13.2781 5.69487C13.3333 5.92505 13.3333 6.16963 13.3333 6.65881Z"
        stroke={color}
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default withStyles(Statements);
